import {
  InformalFeedbackRequest,
  InformalFeedbackRequestsClient,
  InformalFeedbackReview,
  InformalFeedbackReviewDismissReason,
} from 'api/clients/InformalFeedbackRequestsClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useState } from 'react'
import { reportError } from 'utils/error'
import Styles from './ReviewerCard.module.scss'
import { Trash2 } from 'blaze-ui/icons'
import { Button } from 'blaze-ui/Button'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { useRefreshInformalFeedbackRequests } from 'hooks/useRefreshInformalFeedbackRequests'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'

export const PendingRequesterActions = ({
  request,
  review,
  setRemoved,
}: {
  request: InformalFeedbackRequest
  review: InformalFeedbackReview
  setRemoved: (value: boolean) => void
}) => {
  const [remindLabel, setRemindLabel] = useState('Remind')
  const { refreshRequests } = useRefreshInformalFeedbackRequests({
    almanacFileId: request.almanac_file.id,
    requestId: request.id,
  })

  const sendReminder = async () => {
    const res = await InformalFeedbackRequestsClient.sendReviewReminder(review.id)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      setRemindLabel('Reminder sent!')
      showToastMessage('Reminder sent!', 'success')
    } else {
      showErrorMessageToast('An error occurred! Our team has been notified and we are looking into it.')
      reportError('Failed to send reminder', {
        severity: 'error',
        metaData: { request },
      })
    }
  }

  const remove = async () => {
    setRemoved(true)

    const res = await InformalFeedbackRequestsClient.dismissReview(review.id, {
      reason: InformalFeedbackReviewDismissReason.RemovedFromReview,
    })

    if (res?.type === SUCCESS_RESPONSE_TYPE) {
      refreshRequests()
      showToastMessage('The user was removed from the review', 'success')
    } else {
      setRemoved(false)
      reportError('Failed to remove reviewer', {
        severity: 'error',
        metaData: { review },
      })
      showErrorMessageToast('The user could not be removed.')
    }
  }

  return (
    <div className={Styles.actions}>
      <ResponsiveDesign.Desktop>
        {remindLabel !== 'Remind' ? (
          <span className={Styles.infoLabel}>{remindLabel}</span>
        ) : (
          <Button size="xs" variant="ghost" onPress={sendReminder}>
            {remindLabel}
          </Button>
        )}
      </ResponsiveDesign.Desktop>
      <IconButton variant="editor" title="delete" size='xs' icon={Trash2} onPress={remove} />
    </div>
  )
}
